define(['jquery','pubsub'], function($){

	var DEBUG = false;

	var StateManager = function ( stateInstanceName, state ) {
		this.state = state || {};
		this.stateInstanceName = stateInstanceName || null;
	};

	StateManager.prototype = {

		/**
		*	toggle sets a boolean property to false if true, or true if false on the state
		*	Publishes a pubsub event with the property name concatenated with .TOGGLED
		*/
		toggle : function ( property ) {

			if ( DEBUG ) console.log('state data toggle : ', property);

			this.state[property] = !this.state[property];

			this.publishStateChange(this.stateInstanceName + '.TOGGLED.' + property);
			
			return this;

		},

		/**
		*	enable sets a boolean property to true on the state
		*	Publishes a pubsub event with the property name concatenated with .ENABLED
		*/
		enable : function ( property ) {

			if ( DEBUG ) console.log('state data enable : ', property);

			this.state[property] = true;

			this.publishStateChange(this.stateInstanceName + '.ENABLED.' + property);
			

			return this;

		},

		/**
		*	disable sets a boolean property to false on the state
		*	Publishes a pubsub event with the property name concatenated with .DISABLED
		*/
		disable : function ( property ) {

			if ( DEBUG ) console.log('state data disable : ', property);

			this.state[property] = false;

			this.publishStateChange(this.stateInstanceName + '.DISABLED.' + property);
			
			return this;

		},

		/**
		*	getProperty - returns property value from state object
		*	@param property name of property to be queried for the value
		*/
		getProperty : function ( property ) {

			if ( DEBUG ) console.log('state data getProperty : ', property);

			return this.state[property];

		},

		/**
		*	setProperty sets a property name and value on the state
		*	@param property - object containing a single key value pair with the 
		*	property name and value to be set on the state
		*	Publishes a pubsub event with the property name concatenated with .UPDATED
		*/
		setProperty : function ( property ) {

			if ( DEBUG ) console.log('state setProperty : ', property);

			this.state[ Object.keys(property)[0] ] = this.objectValues(property)[0];

			this.publishStateChange(this.stateInstanceName + '.UPDATED.' + Object.keys(property)[0]);

			return this;

		},

		/**
		*	getState returns the state object
		*/
		getState : function () {

			if ( DEBUG ) console.log('getState');

			return this.state;

		},

		/**
		*	addArrayItem adds an item to a given array
		*	@param data - object single property - key is name of array, value is array
		*	Publishes pubsub event with key concatenated with .UPDATED
		*/
		addArrayItem : function ( data ) {

			if ( DEBUG ) console.log('state data addArrayItem : ', data);

			if ( typeof this.state[data.lot] === 'undefined' ) {
				this.state[data.lot] = [];
			}

			if ( this.state[data.lot].indexOf(data.value) === -1 ) {
				this.state[data.lot].push(data.value);
			} 

			this.publishStateChange(this.stateInstanceName + '.UPDATED.' + data.lot);

			return this;
		},


		/**
		*	updateArrayItem - update existing array item on selected array with new value
		*	do nothing if array item does not exist on array
		*	@param data object
		*	Publishes pubsub event with key concatenated with .UPDATED
		*/
		updateArrayItem : function ( data ) {

			if ( DEBUG ) console.log('state data updateArrayItem : ', data);

			if ( this.state[data.lot].indexOf(data.value) !== -1 ) {
				this.state[data.lot][this.state[data.lot].indexOf(data.value)] = data.value;
			}

			this.publishStateChange(this.stateInstanceName + '.UPDATED.' + data.lot);

			return this;
		},	

		/**
		*	removeArrayItem removes an item from a given array
		*	@param data - object single property - key is name of array, value is array
		*	Publishes pubsub event with key concatenated with .UPDATED
		*/
		removeArrayItem : function ( data ) {

			if ( DEBUG ) console.log('state data removeArrayItem : ', data);

			this.state[data.lot].splice(this.state[data.lot].indexOf(data.value), 1);

			this.publishStateChange(this.stateInstanceName + '.UPDATED.' + data.lot);

			return this;

		},

		/**
		*	clearArray resets a given array that is a value of a property on the state
		*	@param data - object single property - key is name of array, value is array
		*	Publishes pubsub event with key concatenated with .CLEARED
		*/
		clearArray : function (data) {

			if ( DEBUG ) console.log('state data clearArray : ',data);

			this.state[data] = [];

			this.publishStateChange(this.stateInstanceName + '.CLEARED.' + data);
			
			return this;

		},

		deleteProperty : function (propertyKey) {

			if ( DEBUG ) consosle.log('state property delete : ', propertyKey);

			delete this.state[propertyKey];

			this.publishStateChange(this.stateInstanceName + '.DELETED.' + propertyKey);
		},

		/**
		*	clearState resets the state to an empty Object
		*	@param stateIntanceName optional 'string' name property assigned to instance of state within calling module
		*	Publishes event with name of state instance concatenated with .CLEARED
		*/
		clearState : function() {

			if ( DEBUG ) console.log('clearing state');

			this.state = {};
			
			this.publishStateChange(this.stateInstanceName + '.CLEARED');
			
			return this;
		},

		publishStateChange : function (event) {
			
			if ( DEBUG ) console.log('publishing : ', event);

			if ( this.stateInstanceName ) {
				$.pubsub('publish', event);	
			}
		},

		// IE doesn't support Object.values() - this function takes care of it
		objectValues : function ( obj ) {

			if ( DEBUG ) console.log('objectValues : ', obj);

		    var res = [];
		    for (var i in obj) {
		        if ( obj.hasOwnProperty(i) ) {
		            res.push(obj[i]);
		        }
		    }
		    return res;
		}

	};

	return StateManager;

});